(function () {
    'use strict';

    a3_cabin_reports.directive('jumpseatRequestFormPanel', jumpseatRequestFormPanel);

    /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name jumpseatRequestFormPanel
     * @description
     *   Renders the Jumpseat Request form panel and uses parent scope form model.
     */
    function jumpseatRequestFormPanel() {
        /**
         * Initialize panel expand/collapse state.
         * @param {object} scope directive scope
         */
        function link(scope) {
            scope.requestFormPanelState = {
                isOpen: true
            };

            scope.toggleRequestFormPanel = toggleRequestFormPanel;

            /**
             * Toggle request form panel visibility.
             */
            function toggleRequestFormPanel() {
                scope.requestFormPanelState.isOpen = !scope.requestFormPanelState.isOpen;
            }
        }

        return {
            restrict: 'E',
            templateUrl: 'views/JumpseatRequests/requestFormPanel.tpl.html',
            scope: false,
            link: link
        };
    }
})();
